module.exports = __webpack_public_path__ + "static/img/1.8098824.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/1.png
// module id = 8EsV
// module chunks = 0